define([
    "./hereMapsModule",
    "@here/maps-api-for-javascript"
], function (hereMapsModule, H) {
    "use strict";

    hereMapsModule.controller("hereMapsController", [
            "$scope",
            "$window",
            "$timeout",
            "$translate",
            "$element",
            "hereMapsService",
            "hereMapsConfigurationLoader",
            "hereMapsConfiguration",
            "hereMapsLocalization",
            "hereMapsConstant",
            "hereMapsActionsService",
            "hereMapsMarkersFactory",
            "hereMapsPolygonDrawingManagerFactory",
            "hereMapsLoadingService",
            function ($scope,
                      $window,
                      $timeout,
                      $translate,
                      $element,
                      hereMapsService,
                      hereMapsConfigurationLoader,
                      hereMapsConfiguration,
                      hereMapsLocalization,
                      hereMapsConstant,
                      hereMapsActionsService,
                      hereMapsMarkersFactory,
                      hereMapsPolygonDrawingManagerFactory,
                      hereMapsLoadingService) {
                $scope.Here = H.default;
                $scope.loading = true;
                $scope.error = false;
                $scope.ready = false;
                $scope.readyMaps = false;
                $scope.lg = $translate.use();
                $scope.maps.mode = hereMapsConstant.NAVIGATE_MODE;

                var onPointerMove = null;

                $scope.mapsActions = {
                    fullScreen: toggleMapFullScreen,
                    focusOnMarkers: focusOnMarkers
                };

                var onMapMarkerRegisterApi =  null;

                $scope.onMapMarkerRegisterApi = function (api) {
                    onMapMarkerRegisterApi = api;
                };

                $scope.mapsApis = {
                    onMapMarkerRegisterApi: $scope.onMapMarkerRegisterApi
                };


                hereMapsConfigurationLoader.load().then(function () {
                    $scope.loading = false;
                    $scope.ready = true;
                    // timeOut para contruir o mapa
                    $timeout(function () {
                        createMap();
                    }, 0);
                }).catch(function () {
                    $scope.loading = false;
                    $scope.error = true;
                });

                function createMap() {
                    $scope.config = hereMapsConfiguration.getConfig();

                    if (!$scope.config || !$scope.config.apiKey) {
                        $scope.error = true;
                        return;
                    }

                    var platform = new $scope.Here.service.Platform({
                        apikey: $scope.config.apiKey,
                    });

                    var defaultLayers = platform.createDefaultLayers({
                        lg: $scope.lg
                    });

                    $scope.map = new $scope.Here.Map(
                        $element.find(".map-container")[0],
                        defaultLayers.vector.normal.map,
                        {
                            zoom: 5,
                            center: {lat: -23.6099993, lng: -46.6948204},
                            pixelRatio: $window.devicePixelRatio || 1
                        }
                    );

                    $scope.behavior = new $scope.Here.mapevents.Behavior(
                        new $scope.Here.mapevents.MapEvents($scope.map)
                    );

                    $timeout(function () {
                        onResize();
                    }, 100);

                    $scope.ui = $scope.Here.ui.UI.createDefault(
                        $scope.map, defaultLayers, hereMapsLocalization.getLocalization($scope.lg));

                    hereMapsService.register({
                        map: $scope.map,
                        here: $scope.Here,
                        behavior: $scope.behavior,
                        ui: $scope.ui
                    });

                    if ($scope.markersData) {
                        $scope.markersData.markers = hereMapsMarkersFactory
                            .createMarkers($scope.markersData);
                    }
                    if ($scope.polygonsData) {
                        $scope.polygonsData.polygonsHere = hereMapsPolygonDrawingManagerFactory
                            .createPolygons($scope.polygonsData);
                    }

                    $scope.readyMaps = true;
                    createEvents();
                }

                function createEvents() {
                    $window.addEventListener("resize", onResize);

                    onPointerMove = function (event) {
                        if (!event) {
                            return;
                        }
                        if (event.target instanceof $scope.Here.map.Marker
                        || (event.target instanceof $scope.Here.map.Polyline && $scope.maps.changeCursorOnRoute) ) {
                            $scope.map.getViewPort().element.style.cursor = "pointer";
                        } else {
                            $scope.map.getViewPort().element.style.cursor = "auto";
                        }
                    };
                    $scope.map.addEventListener("pointermove", onPointerMove);
                }

                function onResize() {
                    if ($scope.map) {
                        $scope.map.getViewPort().resize();
                    }
                }

                function toggleMapFullScreen() {
                    var map_container = $element.find(".here-maps")[0];
                    hereMapsActionsService.fullScreen(map_container);
                }


                function focusOnMarkers () {
                    onMapMarkerRegisterApi.centerMapOnMarkersWithPadding(75);
                }

                $scope.isFullScreen = function () {
                    return !!hereMapsActionsService.isFullScreen();
                };

                $scope.startNavigate = function () {
                    $scope.maps.mode = hereMapsConstant.NAVIGATE_MODE;
                };

                $scope.startDrawing = function () {
                    $scope.maps.mode = hereMapsConstant.DRAWING_MODE;
                };

                $scope.startFreehandDrawing = function () {
                    $scope.maps.mode = hereMapsConstant.FREEHAND_DRAWING_MODE;
                };

                $scope.startRectSelection = function () {
                    $scope.maps.mode = hereMapsConstant.RECT_SELECTION;
                };

                $scope.isActive = function (mode) {
                    return $scope.maps.mode === mode;
                };

                $scope.getNavigateMode = function () {
                    return hereMapsConstant.NAVIGATE_MODE;
                };

                $scope.getDrawingMode = function () {
                    return hereMapsConstant.DRAWING_MODE;
                };

                $scope.getFreehandDrawingMode = function () {
                    return hereMapsConstant.FREEHAND_DRAWING_MODE;
                };

                $scope.getRectSelection = function () {
                    return hereMapsConstant.RECT_SELECTION;
                };

                $scope.isEntityLoading = function () {
                    return hereMapsLoadingService.isLoadingHereMaps();
                };

                $scope.$on("$destroy", function () {
                    if ($scope.map) {
                        $window.removeEventListener("resize", onResize);
                        $timeout.cancel();

                        $scope.map.removeEventListener("pointermove", onPointerMove);

                        hereMapsService.clear();
                        $scope.map.dispose();
                        $scope.map = null;
                        $scope.behavior = null;
                        $scope.ui = null;
                    }
                });
            }
        ]
    );
});